import { Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Invoice } from '../../../../shared/models/invoice.model';
import { CustomUtils } from '../../../../shared/services/custom-utils';

@Component({
  standalone: false,
  selector: 'app-invoice-table-created-at-cell',
  templateUrl: './invoice-table-created-at-cell.component.html',
  host: {
    class: 'w-100',
  },
})
export class InvoiceTableCreatedAtCellComponent implements ICellRendererAngularComp {
  cellData = signal<Invoice | null>(null);

  isAutoGenerated = computed(() => this.cellData()?.autoGenerated ?? false);
  dateDisplay = computed(() => {
    const formattedDate = CustomUtils.formatDate(this.cellData().createdAt);

    return {
      date: formattedDate[0],
      time: formattedDate[1],
    };
  });

  agInit(params: ICellRendererParams<Invoice>): void {
    this.setData(params);
  }

  refresh(params: ICellRendererParams<Invoice>): boolean {
    this.setData(params);
    return true;
  }

  private setData(params: ICellRendererParams<Invoice>) {
    this.cellData.set(params.data!);
  }
}
